<template>
  <v-dialog
    width="500"
    content-class="dialog-send-by-email"
    v-model="modalOpen">
    <v-card>
      <v-card-title>
        <v-flex class="text-xs-right">
          <a href="#" @click.stop.prevent="closeModal()">
            {{ $t('close') }}
            <v-icon>close</v-icon>
          </a>
        </v-flex>
      </v-card-title>
      <v-card-text>
        <v-layout
          align-center
          justify-space-between
          column
          fill-height
          wrap
          class="dialog-title"
        >
          <v-text-field
            type="mail"
            v-bind:label="$t('enter_your_email')"
            v-model="email"
            v-bind:placeholder="$t('example_email')"
            class="email-notify-me"
            :rules="[rules.required, rules.email]"
          ></v-text-field>
          <v-btn class="v-btn v-btn--flat v-btn--round theme--light" @click="sendEmail()">{{ $t('send') }}</v-btn>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "SchoolSendMailModal",
  data() {
    return {
      modalOpen: false,
      email: null,
      schoolId: null,
      rules: {
        required: value => !!value || "Required.",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || this.$t('invalid_email');
        }
      }
    };
  },
  computed: {
    emailIsValid() {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email);
    }
  },
  methods: {
    openModal(config = {}) {
      const {schoolId} = config;
      this.schoolId = schoolId;
      this.modalOpen = true;
    },
    closeModal() {
      this.modalOpen = false;
    },

    sendEmail() {
      if (this.modalOpen && this.emailIsValid) {
        let subject = "Fraser Institute - School Rankings";
        let body = location.href;

        if (this.schoolId) {
          body += `school/${this.schoolId}`;
        }

        window.open(
          `mailto:${this.email}?subject=${subject}&body=${body}`,
          "_self"
        );
        this.closeModal();
      }
    },
  }
};
</script>
